import { useSetAtom } from 'jotai';
import { dodAtom, sliceAreaAtom } from '../atoms';
import { useDispatch } from 'react-redux';
import { clearCompareFiltersOnTrends } from '@src/store/trends/base/actions';
import { setSlice } from '@src/store/trends/birdChart/actions';

function useTabSwitch() {
  const dispatch = useDispatch();
  const setDod = useSetAtom(dodAtom);
  const setSliceArea = useSetAtom(sliceAreaAtom);

  const widgetPanelSwitchCleanup = () => {
    setDod(false);
    dispatch(clearCompareFiltersOnTrends());
    setSliceArea([]);
    dispatch(setSlice([0, 100], [0, 0]));
  };

  const metricPanelSwitchCleanup = () => {
    setSliceArea([]);
    dispatch(setSlice([0, 100], [0, 0]));
  };

  return { widgetPanelSwitchCleanup, metricPanelSwitchCleanup };
}

export default useTabSwitch;
